import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import PageHeader from '../components/PageHeader';
import MinPricesPage from '../components/MinPricesPage';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import SEO from '../components/SEO';

// Использование:

const PageContainer = styled.div`
  background-color: #ededed;
  min-height: 100vh;
`;

const MinPrices = () => {
    
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <SEO 
        title="Минимальные цены на туры | Максимум Тур - Дешевые путевки"
        description="Туры по минимальным ценам от турагентства Максимум Тур. Самые дешевые путевки по всему миру из Владивостока. Гарантия лучших цен на отдых."
        keywords="минимальные цены, дешевые туры, недорогие путевки, бюджетный отдых, эконом тур, Максимум Тур, Владивосток"
        type="website"
      />
      <Menu />
      <Header />
      <PageHeader />
      <MinPricesPage />
      <ContactForm />
      <Footer />
    </PageContainer>
  );
};

export default MinPrices;